import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: 'a4f4710e770a62f29258',
  cluster: 'ap2',
  forceTLS: true,
});

export default function CaisseHome() {
  const { user, logout } = useAuth();
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onglet, setOnglet] = useState('commandes');
  const [dashboard, setDashboard] = useState(null);
  const [historique, setHistorique] = useState([]);
  const [time, setTime] = useState(new Date());
  const [caissierNom, setCaissierNom] = useState(user?.name || '');
  const [modalCommande, setModalCommande] = useState(null);
  const [modePaiement, setModePaiement] = useState('especes');
  const [factureEnCours, setFactureEnCours] = useState(false);

  const chargerCommandes = () => {
    api.get('/caisse/commandes').then((res) => {
      setCommandes(res.data);
      setLoading(false);
    });
  };

  const chargerDashboard = () => {
    api.get('/caisse/dashboard').then((res) => setDashboard(res.data));
  };

  const chargerHistorique = () => {
    api.get('/caisse/historique').then((res) => setHistorique(res.data.data || []));
  };

  useEffect(() => {
    chargerCommandes();
    chargerDashboard();
    const interval = setInterval(() => { chargerCommandes(); chargerDashboard(); }, 5000);
    const clock = setInterval(() => setTime(new Date()), 1000);
    echo.channel('commandes').listen('.nouvelle.commande', () => {
      chargerCommandes();
      chargerDashboard();
    });
    return () => {
      clearInterval(interval);
      clearInterval(clock);
      echo.leaveChannel('commandes');
    };
  }, []);

  useEffect(() => {
    if (onglet === 'historique') chargerHistorique();
    if (onglet === 'dashboard') chargerDashboard();
  }, [onglet]);

  const ouvrirModal = (commande) => {
    setModalCommande(commande);
    setModePaiement('especes');
  };

  const facturer = async () => {
    if (!modalCommande) return;
    setFactureEnCours(true);
    try {
      await api.post('/caisse/facturer/' + modalCommande.id, { mode_paiement: modePaiement });
      imprimerFacture(modalCommande, modePaiement);
      setModalCommande(null);
      chargerCommandes();
      chargerDashboard();
    } catch (err) {
      alert('Erreur lors de la facturation');
    } finally {
      setFactureEnCours(false);
    }
  };

  const imprimerFacture = (commande, mode) => {
    const lignesHtml = (commande.lignes || []).map(l =>
      '<div class="ligne"><span>' + (l.article ? l.article.nom : '') + ' x' + l.quantite + '</span><span>' + (l.sous_total ? l.sous_total.toLocaleString() : 0) + ' Ar</span></div>'
    ).join('');
    const contenu = '<html><head><title>Facture</title>'
      + '<style>*{margin:0;padding:0;box-sizing:border-box;}body{font-family:monospace;width:300px;margin:0 auto;padding:16px;font-size:13px;}'
      + 'h1{text-align:center;font-size:18px;letter-spacing:4px;margin-bottom:4px;}'
      + 'h3{text-align:center;font-size:11px;color:#666;margin-bottom:12px;letter-spacing:2px;}'
      + '.info{font-size:12px;margin-bottom:4px;}.ligne{display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px dotted #ccc;}'
      + '.total{display:flex;justify-content:space-between;font-size:16px;font-weight:bold;padding:8px 0;border-top:2px solid black;margin-top:4px;}'
      + '.center{text-align:center;}.footer{margin-top:16px;text-align:center;font-size:11px;color:#666;border-top:1px dashed #ccc;padding-top:12px;}'
      + 'hr{border:none;border-top:1px dashed #ccc;margin:10px 0;}</style></head><body>'
      + '<h1>VAH\'INN</h1><h3>RESORT & SPA - FORT-DAUPHIN</h3><hr/>'
      + '<div class="info">Table : <b>' + (commande.table ? commande.table.numero : '') + '</b> - ' + (commande.table && commande.table.zone ? commande.table.zone.nom : '') + '</div>'
      + '<div class="info">Serveur : ' + (commande.serveur || '') + '</div>'
      + '<div class="info">Caissier : ' + caissierNom + '</div>'
      + '<div class="info">Date : ' + new Date().toLocaleString('fr-FR') + '</div><hr/>'
      + lignesHtml
      + '<div class="total"><span>TOTAL</span><span>' + (commande.total ? commande.total.toLocaleString() : 0) + ' Ar</span></div><hr/>'
      + '<div class="center" style="font-size:13px;font-weight:bold;">Mode : ' + mode.toUpperCase() + '</div>'
      + '<div class="footer">Merci de votre visite !<br/>VAH\'INN RESORT - Fort-Dauphin</div>'
      + '</body></html>';
    const win = window.open('', '_blank', 'width=420,height=650');
    win.document.write(contenu);
    win.document.close();
    win.print();
    win.close();
  };

  const getStatutLabel = (s) => s === 'pret' ? 'Pret' : s === 'en_cuisine' ? 'En cuisine' : 'En attente';
  const getStatutStyle = (s) => {
    if (s === 'pret') return { background: 'rgba(34,197,94,0.15)', color: '#86efac', border: '1px solid rgba(34,197,94,0.3)' };
    if (s === 'en_cuisine') return { background: 'rgba(245,158,11,0.15)', color: '#fde68a', border: '1px solid rgba(245,158,11,0.3)' };
    return { background: 'rgba(239,68,68,0.15)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.3)' };
  };

  const modesPaiement = [
    { id: 'especes', label: 'Especes', icon: '💵' },
    { id: 'carte', label: 'Carte', icon: '💳' },
    { id: 'virement', label: 'Virement', icon: '🏦' },
    { id: 'chambre', label: 'Chambre', icon: '🏨' },
  ];

  if (loading) return (
    <div style={s.loadingScreen}>
      <div style={s.loadingLogo}>VAH'INN</div>
      <div style={s.loadingSub}>Caisse</div>
    </div>
  );

  return (
    <div style={s.app}>
      <style>{globalStyles}</style>

      {modalCommande && (
        <div style={s.overlay} onClick={() => setModalCommande(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div>
                <div style={s.modalTitle}>Facturer</div>
                <div style={s.modalSub}>Table {modalCommande.table?.numero} — {modalCommande.table?.zone?.nom}</div>
              </div>
              <button style={s.closeBtn} onClick={() => setModalCommande(null)}>✕</button>
            </div>

            <div style={s.modalArticles}>
              {modalCommande.lignes?.map((l) => (
                <div key={l.id} style={s.modalLigne}>
                  <span style={s.modalQte}>x{l.quantite}</span>
                  <span style={s.modalNom}>{l.article?.nom}</span>
                  <span style={s.modalPrix}>{l.sous_total?.toLocaleString()} Ar</span>
                </div>
              ))}
            </div>

            <div style={s.modalTotal}>
              <span style={{fontSize:'14px',color:'#94a3b8'}}>TOTAL</span>
              <span style={s.modalTotalMontant}>{modalCommande.total?.toLocaleString()} Ar</span>
            </div>

            <div style={s.infoRow}>
              <span style={s.infoLabel}>Serveur</span>
              <span style={s.infoVal}>👤 {modalCommande.serveur}</span>
            </div>

            <div style={s.inputGroup}>
              <label style={s.inputLabel}>Nom du caissier</label>
              <input
                style={s.input}
                value={caissierNom}
                onChange={e => setCaissierNom(e.target.value)}
                placeholder="Votre nom complet..."
              />
            </div>

            <div style={s.inputGroup}>
              <label style={s.inputLabel}>Mode de paiement</label>
              <div style={s.modesGrid}>
                {modesPaiement.map(m => (
                  <button
                    key={m.id}
                    style={{...s.modeBtn, ...(modePaiement === m.id ? s.modeBtnActive : {})}}
                    onClick={() => setModePaiement(m.id)}
                  >
                    <span style={{fontSize:'24px'}}>{m.icon}</span>
                    <span style={{fontSize:'11px',fontWeight:'600'}}>{m.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <button
              style={{...s.btnFacturer, ...(factureEnCours || !caissierNom ? s.btnDisabled : {})}}
              onClick={facturer}
              disabled={factureEnCours || !caissierNom}
            >
              {factureEnCours ? 'En cours...' : 'Valider et Imprimer'}
            </button>
          </div>
        </div>
      )}

      <header style={s.header}>
        <div>
          <div style={s.logo}>VAH'INN</div>
          <div style={s.logoSub}>Caisse</div>
        </div>
        <div style={{textAlign:'center'}}>
          <div style={s.clock}>{time.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</div>
          <div style={s.dateStr}>{time.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
        </div>
        <div style={s.headerRight}>
          <div style={s.userBadge}>
            <div style={s.avatar}>{user?.name?.charAt(0)}</div>
            <div>
              <div style={s.userName}>{user?.name}</div>
              <div style={s.userRole}>Caisse</div>
            </div>
          </div>
          <button style={s.logoutBtn} onClick={logout}>⏻</button>
        </div>
      </header>

      <div style={s.tabs}>
        {[
          { id: 'commandes', label: 'Commandes', count: commandes.length },
          { id: 'dashboard', label: 'Dashboard', count: null },
          { id: 'historique', label: 'Historique', count: null },
        ].map(tab => (
          <button
            key={tab.id}
            style={{...s.tab, ...(onglet === tab.id ? s.tabActive : {})}}
            onClick={() => setOnglet(tab.id)}
          >
            {tab.label}
            {tab.count !== null && (
              <span style={{...s.tabCount, ...(onglet === tab.id ? s.tabCountActive : {})}}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>

      <div style={s.content}>

        {onglet === 'commandes' && (
          <div>
            {commandes.length === 0 ? (
              <div style={s.empty}>
                <div style={{fontSize:'48px'}}>💰</div>
                <div style={s.emptyText}>Aucune commande en cours</div>
              </div>
            ) : (
              <div style={s.grid}>
                {commandes.map((commande) => (
                  <div key={commande.id} style={s.card}>
                    <div style={s.cardHeader}>
                      <div>
                        <div style={s.tableNum}>{commande.table?.numero}</div>
                        <div style={s.tableZone}>{commande.table?.zone?.nom}</div>
                      </div>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'6px'}}>
                        <div style={{...s.statutPill, ...getStatutStyle(commande.statut)}}>
                          {getStatutLabel(commande.statut)}
                        </div>
                        <div style={s.serveurTag}>👤 {commande.serveur}</div>
                        <div style={s.heureTag}>
                          {new Date(commande.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                        </div>
                      </div>
                    </div>

                    <div style={s.articlesList}>
                      {commande.lignes?.map((l) => (
                        <div key={l.id} style={s.articleRow}>
                          <div style={s.qteBadge}>x{l.quantite}</div>
                          <span style={s.articleNom}>{l.article?.nom}</span>
                          <span style={s.articlePrix}>{l.sous_total?.toLocaleString()} Ar</span>
                        </div>
                      ))}
                    </div>

                    {commande.note && (
                      <div style={s.noteBox}>📝 {commande.note}</div>
                    )}

                    <div style={s.cardFooter}>
                      <div>
                        <div style={s.totalLabel}>Total</div>
                        <div style={s.totalMontant}>{commande.total?.toLocaleString()} Ar</div>
                      </div>
                      <button style={s.btnCard} onClick={() => ouvrirModal(commande)}>
                        Facturer
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {onglet === 'dashboard' && dashboard && (
          <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
            <div style={s.dashCards}>
              <div style={{...s.dashCard, background:'linear-gradient(135deg,#052e16,#14532d)', border:'1px solid rgba(34,197,94,0.3)'}}>
                <div style={s.dashNum}>{dashboard.chiffre_aujourdhui?.toLocaleString()}</div>
                <div style={s.dashLabel}>Ariary encaisses aujourd hui</div>
              </div>
              <div style={{...s.dashCard, background:'linear-gradient(135deg,#0c1a3a,#1e3a6e)', border:'1px solid rgba(59,130,246,0.3)'}}>
                <div style={s.dashNum}>{dashboard.commandes_en_cours}</div>
                <div style={s.dashLabel}>Commandes en cours</div>
              </div>
              <div style={{...s.dashCard, background:'linear-gradient(135deg,#450a0a,#7f1d1d)', border:'1px solid rgba(239,68,68,0.3)'}}>
                <div style={s.dashNum}>{dashboard.tables_occupees}</div>
                <div style={s.dashLabel}>Tables occupees</div>
              </div>
            </div>
            <div style={s.topCard}>
              <div style={s.topTitle}>Top articles du jour</div>
              {dashboard.top_articles?.length === 0 ? (
                <div style={s.emptyText}>Aucune vente</div>
              ) : dashboard.top_articles?.map((item, i) => (
                <div key={i} style={s.topRow}>
                  <div style={s.topRank}>#{i+1}</div>
                  <div style={{flex:1,fontSize:'13px',color:'#cbd5e1'}}>{item.article?.nom}</div>
                  <div style={{fontSize:'14px',fontWeight:'700',color:'#f59e0b'}}>x{item.total_vendu}</div>
                </div>
              ))}
            </div>
          </div>
        )}
{onglet === 'historique' && (
  <div>
    <div style={{fontSize:'16px', fontWeight:'700', color:'#f1f5f9', marginBottom:'14px'}}>Historique des factures</div>
    {historique.length === 0 ? (
      <div style={s.empty}>
        <div style={{fontSize:'48px'}}>🕐</div>
        <div style={s.emptyText}>Aucune facture</div>
      </div>
    ) : (
      <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
        {historique.map((facture) => (
          <div key={facture.id} style={s.factureRow}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'10px'}}>
              <div>
                <div style={{fontSize:'13px', fontWeight:'700', color:'#f1f5f9'}}>{facture.numero_facture}</div>
                <div style={{fontSize:'12px', color:'#64748b'}}>
                  {"Table " + (facture.commande?.table?.numero || '') + " — " + (facture.commande?.table?.zone?.nom || '')}
                </div>
                <div style={{fontSize:'11px', color:'#475569'}}>
                  {new Date(facture.created_at).toLocaleString('fr-FR')}
                </div>
              </div>
              <div style={{textAlign:'right'}}>
                <div style={{fontSize:'18px', fontWeight:'800', color:'#22c55e'}}>{facture.total?.toLocaleString()} Ar</div>
                <div style={{fontSize:'11px', color:'#64748b', textTransform:'uppercase', letterSpacing:'1px'}}>{facture.mode_paiement}</div>
              </div>
            </div>
            <div style={{background:'rgba(0,0,0,0.2)', borderRadius:'10px', padding:'8px', marginBottom:'10px'}}>
              {facture.commande?.lignes?.map((l, i) => (
                <div key={i} style={{display:'flex', justifyContent:'space-between', padding:'4px 0', borderBottom:'1px solid rgba(51,65,85,0.3)', fontSize:'12px'}}>
                  <span style={{color:'#94a3b8'}}>
                    <span style={{color:'#f59e0b', fontWeight:'700', marginRight:'8px'}}>x{l.quantite}</span>
                    {l.article?.nom}
                    {l.note ? <span style={{color:'#a5b4fc', fontStyle:'italic'}}> ({l.note})</span> : null}
                  </span>
                  <span style={{color:'#cbd5e1', fontWeight:'600'}}>{l.sous_total?.toLocaleString()} Ar</span>
                </div>
              ))}
            </div>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
              <div style={{fontSize:'11px', color:'#475569'}}>
                Caissier : <span style={{color:'#94a3b8', fontWeight:'600'}}>{facture.caissier_nom || 'N/A'}</span>
              </div>
              <button
                style={{padding:'8px 16px', borderRadius:'10px', border:'1px solid rgba(245,158,11,0.3)', background:'rgba(245,158,11,0.1)', color:'#f59e0b', fontSize:'12px', fontWeight:'600'}}
                onClick={() => imprimerFacture(facture.commande, facture.mode_paiement)}
              >
                🖨️ Réimprimer
              </button>
           </div>
          </div>
        ))}
      </div>
    )}
  </div>
)}

      </div>
    </div>
  );
}

const globalStyles = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0a0f1e; }
  button { transition: transform 0.15s, opacity 0.15s; cursor: pointer; }
  button:active { transform: scale(0.96) !important; }
  input:focus { outline: none; border-color: rgba(245,158,11,0.6) !important; }
  ::-webkit-scrollbar { width: 4px; } 
  ::-webkit-scrollbar-thumb { background: #334155; border-radius: 2px; }
`;

const s = {
  app: { minHeight:'100vh', background:'linear-gradient(160deg,#0a0f1e 0%,#0f172a 50%,#0a0f1e 100%)', fontFamily:"'Segoe UI',system-ui,sans-serif", color:'#e2e8f0', paddingBottom:'32px' },
  loadingScreen: { minHeight:'100vh', background:'#0a0f1e', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'8px' },
  loadingLogo: { fontSize:'42px', fontWeight:'900', letterSpacing:'8px', color:'#f59e0b' },
  loadingSub: { fontSize:'14px', letterSpacing:'4px', color:'#64748b', textTransform:'uppercase' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' },
  modal: { background:'linear-gradient(145deg,#0f172a,#1e293b)', border:'1px solid rgba(245,158,11,0.3)', borderRadius:'24px', padding:'24px', width:'100%', maxWidth:'480px', maxHeight:'90vh', overflowY:'auto', display:'flex', flexDirection:'column', gap:'16px', boxShadow:'0 24px 80px rgba(0,0,0,0.6)' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'flex-start' },
  modalTitle: { fontSize:'22px', fontWeight:'800', color:'#f1f5f9' },
  modalSub: { fontSize:'13px', color:'#64748b', marginTop:'2px' },
  closeBtn: { background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', color:'#ef4444', width:'34px', height:'34px', borderRadius:'50%', fontSize:'16px' },
  modalArticles: { background:'rgba(0,0,0,0.2)', borderRadius:'14px', padding:'12px', display:'flex', flexDirection:'column', gap:'8px' },
  modalLigne: { display:'flex', alignItems:'center', gap:'12px', padding:'6px 0', borderBottom:'1px solid rgba(51,65,85,0.4)' },
  modalQte: { background:'rgba(245,158,11,0.2)', color:'#f59e0b', padding:'2px 10px', borderRadius:'8px', fontSize:'14px', fontWeight:'700', flexShrink:0 },
  modalNom: { flex:1, fontSize:'14px', color:'#cbd5e1' },
  modalPrix: { fontSize:'14px', fontWeight:'600', color:'#f1f5f9' },
  modalTotal: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 16px', background:'rgba(245,158,11,0.08)', border:'1px solid rgba(245,158,11,0.2)', borderRadius:'12px' },
  modalTotalMontant: { fontSize:'26px', fontWeight:'900', color:'#f59e0b' },
  infoRow: { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid rgba(51,65,85,0.4)' },
  infoLabel: { fontSize:'13px', color:'#64748b' },
  infoVal: { fontSize:'13px', fontWeight:'600', color:'#e2e8f0' },
  inputGroup: { display:'flex', flexDirection:'column', gap:'8px' },
  inputLabel: { fontSize:'11px', color:'#64748b', letterSpacing:'1px', textTransform:'uppercase' },
  input: { background:'rgba(15,23,42,0.8)', border:'1px solid rgba(51,65,85,0.6)', borderRadius:'12px', padding:'13px 16px', color:'#f1f5f9', fontSize:'16px', width:'100%', transition:'border-color 0.2s' },
  modesGrid: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'8px' },
  modeBtn: { display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', padding:'12px 8px', borderRadius:'12px', background:'rgba(15,23,42,0.8)', border:'1px solid rgba(51,65,85,0.5)', color:'#94a3b8' },
  modeBtnActive: { background:'rgba(245,158,11,0.15)', border:'1px solid rgba(245,158,11,0.5)', color:'#f59e0b' },
  btnFacturer: { width:'100%', padding:'16px', background:'linear-gradient(135deg,#d97706,#b45309)', border:'none', borderRadius:'14px', color:'#fff', fontSize:'17px', fontWeight:'700', letterSpacing:'0.5px', boxShadow:'0 4px 20px rgba(217,119,6,0.3)' },
  btnDisabled: { opacity:0.4, cursor:'not-allowed' },
  header: { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', background:'rgba(15,23,42,0.95)', borderBottom:'1px solid rgba(245,158,11,0.2)' },
  logo: { fontSize:'20px', fontWeight:'900', letterSpacing:'4px', color:'#f59e0b', lineHeight:1 },
  logoSub: { fontSize:'10px', letterSpacing:'3px', color:'#64748b', textTransform:'uppercase' },
  clock: { fontSize:'26px', fontWeight:'700', color:'#f1f5f9', letterSpacing:'2px' },
  dateStr: { fontSize:'11px', color:'#64748b', textTransform:'capitalize', marginTop:'2px' },
  headerRight: { display:'flex', alignItems:'center', gap:'12px' },
  userBadge: { display:'flex', alignItems:'center', gap:'10px' },
  avatar: { width:'36px', height:'36px', borderRadius:'50%', background:'linear-gradient(135deg,#f59e0b,#d97706)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'16px', fontWeight:'700', color:'#0a0f1e' },
  userName: { fontSize:'13px', fontWeight:'600', color:'#e2e8f0' },
  userRole: { fontSize:'10px', color:'#64748b', textTransform:'uppercase', letterSpacing:'1px' },
  logoutBtn: { background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.3)', color:'#ef4444', width:'36px', height:'36px', borderRadius:'50%', fontSize:'18px' },
  tabs: { display:'flex', background:'rgba(15,23,42,0.8)', borderBottom:'1px solid rgba(51,65,85,0.5)', padding:'0 16px' },
  tab: { display:'flex', alignItems:'center', gap:'8px', padding:'14px 20px', background:'none', border:'none', borderBottom:'2px solid transparent', color:'#64748b', fontSize:'14px', fontWeight:'500', transition:'all 0.2s' },
  tabActive: { borderBottomColor:'#f59e0b', color:'#f59e0b' },
  tabCount: { background:'rgba(51,65,85,0.8)', color:'#64748b', fontSize:'11px', fontWeight:'700', padding:'2px 8px', borderRadius:'10px' },
  tabCountActive: { background:'rgba(245,158,11,0.2)', color:'#f59e0b' },
  content: { padding:'16px' },
  empty: { display:'flex', flexDirection:'column', alignItems:'center', padding:'64px', gap:'12px', background:'rgba(15,23,42,0.5)', borderRadius:'20px', border:'1px solid rgba(51,65,85,0.4)' },
  emptyText: { fontSize:'16px', color:'#475569' },
  grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))', gap:'16px' },
  card: { background:'linear-gradient(145deg,#0f172a,#1e293b)', border:'1px solid rgba(51,65,85,0.6)', borderRadius:'20px', padding:'18px', display:'flex', flexDirection:'column', gap:'14px', boxShadow:'0 4px 20px rgba(0,0,0,0.3)' },
  cardHeader: { display:'flex', justifyContent:'space-between', alignItems:'flex-start' },
  tableNum: { fontSize:'34px', fontWeight:'900', color:'#f1f5f9', lineHeight:1 },
  tableZone: { fontSize:'12px', color:'#64748b' },
  statutPill: { fontSize:'12px', fontWeight:'600', padding:'4px 12px', borderRadius:'20px' },
  serveurTag: { fontSize:'12px', color:'#94a3b8' },
  heureTag: { fontSize:'11px', color:'#475569' },
  articlesList: { background:'rgba(0,0,0,0.2)', borderRadius:'12px', padding:'10px', display:'flex', flexDirection:'column', gap:'8px' },
  articleRow: { display:'flex', alignItems:'center', gap:'12px' },
  qteBadge: { background:'rgba(245,158,11,0.15)', border:'1px solid rgba(245,158,11,0.3)', color:'#f59e0b', padding:'3px 10px', borderRadius:'8px', fontSize:'14px', fontWeight:'700', flexShrink:0 },
  articleNom: { flex:1, fontSize:'14px', color:'#cbd5e1' },
  articlePrix: { fontSize:'13px', fontWeight:'600', color:'#94a3b8' },
  noteBox: { padding:'8px 12px', background:'rgba(245,158,11,0.08)', border:'1px solid rgba(245,158,11,0.2)', borderRadius:'10px', fontSize:'13px', color:'#fde68a' },
  cardFooter: { display:'flex', justifyContent:'space-between', alignItems:'center', borderTop:'1px solid rgba(51,65,85,0.5)', paddingTop:'14px' },
  totalLabel: { fontSize:'11px', color:'#64748b', textTransform:'uppercase', letterSpacing:'1px' },
  totalMontant: { fontSize:'22px', fontWeight:'800', color:'#f59e0b' },
  btnCard: { padding:'12px 24px', borderRadius:'12px', border:'none', background:'linear-gradient(135deg,#d97706,#b45309)', color:'#fff', fontSize:'15px', fontWeight:'700', boxShadow:'0 4px 14px rgba(217,119,6,0.25)' },
  dashCards: { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'12px' },
  dashCard: { borderRadius:'16px', padding:'20px 16px', textAlign:'center', display:'flex', flexDirection:'column', gap:'8px' },
  dashNum: { fontSize:'28px', fontWeight:'900', color:'#f1f5f9' },
  dashLabel: { fontSize:'12px', color:'#94a3b8' },
  topCard: { background:'rgba(15,23,42,0.8)', border:'1px solid rgba(51,65,85,0.5)', borderRadius:'16px', padding:'16px', display:'flex', flexDirection:'column', gap:'10px' },
  topTitle: { fontSize:'14px', fontWeight:'700', color:'#f1f5f9', marginBottom:'4px' },
  topRow: { display:'flex', alignItems:'center', gap:'12px', padding:'8px 0', borderBottom:'1px solid rgba(51,65,85,0.4)' },
  topRank: { width:'28px', height:'28px', borderRadius:'8px', background:'rgba(245,158,11,0.15)', color:'#f59e0b', fontSize:'12px', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'center' },
  factureRow: { display:'flex', justifyContent:'space-between', alignItems:'center', background:'rgba(15,23,42,0.8)', border:'1px solid rgba(51,65,85,0.5)', borderRadius:'14px', padding:'14px 18px' },
};
